export const GET_REIMPORT_DATA = "GET_REIMPORT_DATA";
export const GET_REIMPORT_DATA_SUCCESS = "GET_REIMPORT_DATA_SUCCESS";
export const GET_REIMPORT_DATA_ERROR = "GET_REIMPORT_DATA_ERROR";

export const POST_REIMPORT_DATA = "POST_REIMPORT_DATA";
export const POST_REIMPORT_DATA_SUCCESS = "POST_REIMPORT_DATA_SUCCESS";
export const POST_REIMPORT_DATA_ERROR = "POST_REIMPORT_DATA_ERROR";

export const GET_EXPORT_LOAD_LIST = "GET_EXPORT_LOAD_LIST";
export const GET_EXPORT_LOAD_LIST_SUCCESS = "GET_EXPORT_LOAD_LIST_SUCCESS";
export const GET_EXPORT_LOAD_LIST_ERROR = "GET_EXPORT_LOAD_LIST_ERROR";

export const PUT_COMPLETE_REIMPORT = "PUT_COMPLETE_REIMPORT";
export const PUT_COMPLETE_REIMPORT_SUCCESS = "PUT_COMPLETE_REIMPORT_SUCCESS";
export const PUT_COMPLETE_REIMPORT_ERROR = "PUT_COMPLETE_REIMPORT_ERROR";

export const DELETE_REIMPORT = "DELETE_REIMPORT";
export const DELETE_REIMPORT_SUCCESS = "DELETE_REIMPORT_SUCCESS";
export const DELETE_REIMPORT_ERROR = "DELETE_REIMPORT_ERROR";

export const GET_RE_IMPORT_VEHICLES = "GET_RE_IMPORT_VEHICLES";
export const GET_RE_IMPORT_VEHICLES_SUCCESS = "GET_RE_IMPORT_VEHICLES_SUCCESS";
export const GET_RE_IMPORT_VEHICLES_ERROR = "GET_RE_IMPORT_VEHICLES_ERROR";

export const GET_REIMPORT_DATA_BY_VIN = "GET_REIMPORT_DATA_BY_VIN";
export const GET_REIMPORT_DATA_BY_VIN_SUCCESS = "GET_REIMPORT_DATA_BY_VIN_SUCCESS";
export const GET_REIMPORT_DATA_BY_VIN_ERROR = "GET_REIMPORT_DATA_BY_VIN_ERROR";